/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A class in the class list, with the number of its active members.
 * @export
 * @interface UserClassGroupListItem
 */
export interface UserClassGroupListItem {
    /**
     * 
     * @type {string}
     * @memberof UserClassGroupListItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserClassGroupListItem
     */
    organization_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserClassGroupListItem
     */
    deleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserClassGroupListItem
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof UserClassGroupListItem
     */
    created_on: Date;
    /**
     * 
     * @type {string}
     * @memberof UserClassGroupListItem
     */
    created_by: string;
    /**
     * 
     * @type {number}
     * @memberof UserClassGroupListItem
     */
    member_count: number;
}

/**
 * Check if a given object implements the UserClassGroupListItem interface.
 */
export function instanceOfUserClassGroupListItem(value: object): value is UserClassGroupListItem {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('created_on' in value) || value['created_on'] === undefined) return false;
    if (!('created_by' in value) || value['created_by'] === undefined) return false;
    if (!('member_count' in value) || value['member_count'] === undefined) return false;
    return true;
}

export function UserClassGroupListItemFromJSON(json: any): UserClassGroupListItem {
    return UserClassGroupListItemFromJSONTyped(json, false);
}

export function UserClassGroupListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserClassGroupListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'organization_id': json['organization_id'],
        'deleted': json['deleted'] == null ? undefined : json['deleted'],
        'id': json['id'],
        'created_on': (new Date(json['created_on'])),
        'created_by': json['created_by'],
        'member_count': json['member_count'],
    };
}

export function UserClassGroupListItemToJSON(json: any): UserClassGroupListItem {
    return UserClassGroupListItemToJSONTyped(json, false);
}

export function UserClassGroupListItemToJSONTyped(value?: UserClassGroupListItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'organization_id': value['organization_id'],
        'deleted': value['deleted'],
        'id': value['id'],
        'created_on': ((value['created_on']).toISOString()),
        'created_by': value['created_by'],
        'member_count': value['member_count'],
    };
}

